/* eslint-disable react/prop-types */
import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import JSSidebar from './JSSidebar';
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
import SmallLoading from '../element/SmallLoading';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../helpers';
// mui
import Tooltip from '@mui/material/Tooltip';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const DownloadButton = ({
  t,
  id,
  tokenKey,
}) => {
  const [smallLoading, setSmallLoading] = useState(false);

  const handleDownloadResume = async id => {
    try {
      setSmallLoading(true);

      const response = await axios.post(
        BaseApi + '/download-user-pdf',
        {
          id,
          contacts: true,
        },
        {
          responseType: 'blob',
          headers: {
            key: ApiKey,
            token: tokenKey,
          },
        },
      );

      setSmallLoading(false);

      const url = window.URL.createObjectURL(response.data);
      const filename = response.headers['content-disposition'] ? response.headers['content-disposition'].split('filename=')[1] : 'resume-grc.pdf';

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename.replace(/['"]/g, ''));
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      setSmallLoading(false);

      if (error.response.status === 400) {
        resultInfo('warning', t('jobseekerManageAlert.contactsError'), t('jobseekerManageAlert.close'));
      } else {
        resultInfo('error', t('jobDescription.unsubscribeError'), t('jobseekerManageAlert.close'));
      }

      console.error('Cannot download resume', error);
    }
  };

  return (
    <button
      type='button'
      disabled={smallLoading}
      className='btn-primary button1'
      onClick={() => handleDownloadResume(id)}
    >
      {
        smallLoading
          ? <SmallLoading width='24px' height='24px' color='#FFFFFF' />
          : (
            <Tooltip title={t('jobseekerMyProfile.downloadPDF')}>
              <FileDownloadOutlinedIcon />
            </Tooltip>
          )
      }
    </button>
  );
};

const JSMyCVList = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');

  const [cvList, setCvList] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + '/candidates/getCvList',
        null,
        {
          headers: {
            'Content-Type': 'application/json',
            key: ApiKey,
            token: tokenKey,
          },
        },
      );

      if (response.data.response?.length === 0) {
        navigate('/candidates/editprofile');
      }

      setLoading(false);

      if (response.data.status === 200) {
        setCvList(response.data.response);
      } else if (response.data.status === 400) {
        navigate('/');

        Cookies.remove('fname');
        Cookies.remove('user_id');
        Cookies.remove('user_type');
        Cookies.remove('tokenClient');

        resultInfo('warning', response.data.message, t('jobseekerManageAlert.close'));
      } else {
        resultInfo('error', response.data.message, t('jobseekerManageAlert.close'));
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Cannot get profile data', error);
    }
  };

  useEffect(() => {
    if (userType === 'recruiter' || !tokenKey) {
      navigate('/user/jobseekerlogin');
    } else {
      getData();
      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType]); // eslint-disable-line

  return (
    <>
      <NavBar />
      <div className='container changeLogo'>
        <div className='row'>
          <div className='col-lg-3'>
            <JSSidebar />
          </div>
          {
            loading
              ? (
                <div className='loader-container'></div>
              ) : (
                <div className='col-lg-9 mb-5'>
                  <div className='mx-lg-3 d-flex PageHeader'>
                    <img className='me-2' src='/Images/jobseekerSide/cv-list-color.png' alt='' />
                    <h3>{t('jobseekerMyProfile.myCVList')}</h3>
                  </div>
                  <div className='mx-lg-3 PageHeader'>
                    <div className='MJBody mt-4'>
                      <div className='table-responsive'>
                        <table className='table'>
                          <thead>
                            <tr className='table-active TrFirst'>
                              <th className='' scope='col p-3'>
                                {t('jobseekerMyProfile.cvTitle')}
                              </th>
                              <th className='' scope='col p-3'>
                                {t('jobseekerMyProfile.updated')}
                              </th>
                              <th className='' scope='col p-3'>
                                {t('jobseekerMyProfile.views')}
                              </th>
                              <th>
                                {t('jobseekerMyProfile.status')}
                              </th>
                              <th className='' scope='col p-3'>
                                {t('jobseekerMyProfile.actions')}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              cvList.map(i => (
                                <tr className='TrDefoult' key={i.id}>
                                  <td className=''>
                                    <Link to={`/candidates/my-cv-list/${i.id}`}>
                                      {i.name}
                                    </Link>
                                  </td>
                                  <td className=''>
                                    {i.updated}
                                  </td>
                                  <td className=''>
                                    {i.views}
                                  </td>
                                  <td className='APActionButton'>
                                    {
                                      i.status === 'blocked' && (
                                        <button disabled className='btn-secondary button1'>
                                          <Tooltip title={t('jobseekerMyProfile.blocked')}>
                                            <BlockIcon />
                                          </Tooltip>
                                        </button>
                                      )
                                    }
                                    {
                                      i.status === 'approved' && (
                                        <button disabled className='btn-secondary activated'>
                                          <Tooltip title={t('jobseekerMyProfile.approved')}>
                                            <CheckIcon />
                                          </Tooltip>
                                        </button>
                                      )
                                    }
                                    {
                                      (i.status === 'new' || i.status === 'modified') && (
                                        <button disabled className='btn-secondary button1'>
                                          <Tooltip title={t('jobseekerMyProfile.pending')}>
                                            <HourglassEmptyIcon />
                                          </Tooltip>
                                        </button>
                                      )
                                    }
                                  </td>
                                  <td className='APActionButton'>
                                    <button
                                      className='btn-primary button1'
                                      onClick={() => navigate(`/candidates/editCV/${i.id}`)}
                                    >
                                      <Tooltip title={t('jobseekerMyProfile.edit')}>
                                        <EditOutlinedIcon />
                                      </Tooltip>
                                    </button>
                                    <button
                                      className='btn-primary button1'
                                      onClick={() => navigate(`/candidates/copyCV/${i.id}`)}
                                    >
                                      <Tooltip title={t('jobseekerMyProfile.copy')}>
                                        <FileCopyOutlinedIcon />
                                      </Tooltip>
                                    </button>
                                    <DownloadButton
                                      t={t}
                                      id={i.id}
                                      tokenKey={tokenKey}
                                    />
                                    <button
                                      disabled
                                      className='btn-secondary button1'
                                      // onClick={() => handleDelete(i.slug)}
                                    >
                                      <Tooltip title={t('jobseekerMyProfile.delete')}>
                                        <DeleteIcon />
                                      </Tooltip>
                                    </button>
                                  </td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      </div>
      <Footer />
    </>
  );
};

export default JSMyCVList;
